import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const ORGANISATION_RESOURCE = 'organisation';
export const UPDATE_ORGANISATION_RESOURCE = 'updateOrganisation';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_RESOURCE,
      method: 'get',
      request: id => ({
        url: apiRoutes.getOrganisation(id),
      }),
    },
    {
      resource: UPDATE_ORGANISATION_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.getOrganisation(id),
        body,
        meta: {
          callback,
          toaster: {
            onSuccessMessage: t('organisationUpdated'),
            onErrorMessage: createErrorMessage(t, 'updateOrganisationFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
